
  import { defineComponent } from 'vue';

  import ComponentInput from '@/common/components/ComponentInput.vue';

  import RangeFieldLayout from './RangeFieldLayout.vue';
  import rangeFieldModel from './rangeFieldModel';

  export default defineComponent({
    name: 'TimeRangeField',
    components: { ComponentInput, RangeFieldLayout },
    mixins: [rangeFieldModel],
  });
